(function () {
  'use strict';

  /* ---- Touch detection ---- */
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    document.documentElement.classList.add('fs-is-touch');
  }

  /* ================================================================
     TOAST notification
  ================================================================ */
  var toastEl = null;
  var toastTimer = null;

  function showToast(msg, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fs-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.className = 'fs-toast' + (isError ? ' fs-toast--error' : '') + ' is-visible';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2400);
  }

  /* ================================================================
     CART COUNT REFRESH  (Minimog theme)
  ================================================================ */
  function applyCartCountHtml(sectionHtml) {
    if (!sectionHtml) return false;
    var match = sectionHtml.match(/<m-cart-count[^>]*>([\s\S]*?)<\/m-cart-count>/i);
    var inner = match ? match[1] : null;
    if (inner === null) return false;
    document.querySelectorAll('m-cart-count').forEach(function (el) {
      el.innerHTML = inner;
    });
    return true;
  }

  function refreshCartCount(sectionHtml) {
    if (applyCartCountHtml(sectionHtml)) {
      notifyThemeCartUpdated();
      return;
    }
    fetch('/?section_id=cart-count', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        applyCartCountHtml(html);
        notifyThemeCartUpdated();
      })
      .catch(function () {});
  }

  function notifyThemeCartUpdated() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var detail = { cart: cart, source: 'fs-magic-atc' };
        ['cart-update', 'cart:updated', 'cart:refresh'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
        });
      })
      .catch(function () {});
  }

  /* ================================================================
     QUICK-ADD MODAL
  ================================================================ */
  var qaOverlay = null;
  var qaModal   = null;

  function buildModal() {
    if (qaModal) return;

    qaOverlay = document.createElement('div');
    qaOverlay.className = 'fs-qa-overlay';
    qaOverlay.addEventListener('click', closeModal);

    qaModal = document.createElement('div');
    qaModal.className = 'fs-qa-modal';
    qaModal.setAttribute('role', 'dialog');
    qaModal.setAttribute('aria-modal', 'true');
    qaModal.innerHTML =
      '<button class="fs-qa-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
          '<line x1="18" y1="6" x2="6" y2="18"/>' +
          '<line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
      '<div class="fs-qa-body">' +
        '<img class="fs-qa-img" src="" alt="" loading="lazy">' +
        '<div class="fs-qa-info">' +
          '<div class="fs-qa-title"></div>' +
          '<div class="fs-qa-sizes"></div>' +
          '<button class="fs-qa-atc-btn" disabled>Select a size</button>' +
        '</div>' +
      '</div>';

    qaModal.querySelector('.fs-qa-close').addEventListener('click', closeModal);
    qaModal.querySelector('.fs-qa-atc-btn').addEventListener('click', onModalAtc);

    document.body.appendChild(qaOverlay);
    document.body.appendChild(qaModal);
  }

  function populateModal(product) {
    var atcBtn  = qaModal.querySelector('.fs-qa-atc-btn');
    var sizesEl = qaModal.querySelector('.fs-qa-sizes');
    var titleEl = qaModal.querySelector('.fs-qa-title');
    var imgEl   = qaModal.querySelector('.fs-qa-img');

    titleEl.textContent = product.title || '';

    var imgSrc = '';
    if (product.featured_image) {
      imgSrc = product.featured_image;
    } else if (product.images && product.images.length) {
      imgSrc = product.images[0];
    }
    if (imgSrc) {
      imgSrc = imgSrc.replace(/[?&]v=\d+/, '').split('?')[0];
      imgSrc += '?width=300';
    }
    imgEl.src = imgSrc;
    imgEl.alt = product.title || '';

    atcBtn.disabled = true;
    atcBtn.textContent = 'Select a size';
    atcBtn.dataset.variantId = '';
    sizesEl.innerHTML = '';

    var variants = product.variants || [];

    if (variants.length === 1) {
      sizesEl.style.display = 'none';
      var v = variants[0];
      if (v.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
        atcBtn.dataset.variantId = String(v.id);
      } else {
        atcBtn.textContent = 'Sold Out';
      }
    } else {
      sizesEl.style.display = '';
      var sizeOptionIndex = 0;
      if (product.options) {
        product.options.forEach(function (opt, i) {
          if (/size/i.test(opt)) sizeOptionIndex = i;
        });
      }
      var seen = {};
      variants.forEach(function (v) {
        var sizeLabel = v['option' + (sizeOptionIndex + 1)] || v.option1 || v.title;
        if (seen[sizeLabel]) return;
        seen[sizeLabel] = true;

        var sBtn = document.createElement('button');
        sBtn.className = 'fs-qa-size' + (!v.available ? ' fs-qa-size--sold-out' : '');
        sBtn.textContent = sizeLabel;
        sBtn.dataset.variantId = String(v.id);
        sBtn.disabled = !v.available;

        if (v.available) {
          sBtn.addEventListener('click', function () {
            sizesEl.querySelectorAll('.fs-qa-size').forEach(function (s) {
              s.classList.remove('is-selected');
            });
            sBtn.classList.add('is-selected');
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to Cart';
            atcBtn.dataset.variantId = sBtn.dataset.variantId;
          });
        }
        sizesEl.appendChild(sBtn);
      });

      if (!sizesEl.querySelector('.fs-qa-size:not(.fs-qa-size--sold-out)')) {
        atcBtn.textContent = 'Sold Out';
      }
    }
  }

  function openModal(card) {
    buildModal();

    qaModal.querySelector('.fs-qa-title').textContent = 'Loading\u2026';
    qaModal.querySelector('.fs-qa-img').src = '';
    qaModal.querySelector('.fs-qa-sizes').innerHTML = '';
    var atcBtn = qaModal.querySelector('.fs-qa-atc-btn');
    atcBtn.disabled = true;
    atcBtn.textContent = 'Loading\u2026';

    document.body.classList.add('fs-qa-open');
    qaOverlay.classList.add('is-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        qaModal.classList.add('is-open');
      });
    });

    var handle = '';
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var m = (link.pathname || link.href).match(/\/products\/([^?#\/]+)/);
      if (m) handle = m[1];
    }

    if (!handle) {
      atcBtn.textContent = 'View Product';
      atcBtn.disabled = false;
      qaModal.querySelector('.fs-qa-title').textContent = 'Could not load product';
      return;
    }

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { populateModal(product); })
      .catch(function () {
        atcBtn.textContent = 'Error loading';
        qaModal.querySelector('.fs-qa-title').textContent = 'Please try again';
      });
  }

  function closeModal() {
    if (!qaModal) return;
    qaModal.classList.remove('is-open');
    qaOverlay.classList.remove('is-visible');
    setTimeout(function () {
      document.body.classList.remove('fs-qa-open');
    }, 300);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function onModalAtc() {
    var btn       = qaModal.querySelector('.fs-qa-atc-btn');
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled  = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: ['cart-count'],
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        showToast('Could not add \u2014 ' + (data.description || 'sold out'), true);
        btn.textContent = 'Try again';
        btn.disabled = false;
      } else {
        showToast('Added to cart');
        var sectionHtml = data.sections ? data.sections['cart-count'] : null;
        refreshCartCount(sectionHtml);
        setTimeout(closeModal, 900);
      }
    })
    .catch(function () {
      showToast('Something went wrong', true);
      btn.textContent = 'Error \u2014 try again';
      btn.disabled = false;
    });
  }

  /* ================================================================
     EVENT INTERCEPTION
  ================================================================ */
  var lastTouchAt = 0;

  function getCard(target) {
    return target.closest(
      '.m-product-card, .m-cascading-product-card, ' +
      '[class*="product-card"], [class*="product_card"]'
    );
  }

  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.m-atc-btn')) return;
    e.stopPropagation();
    e.preventDefault();
    lastTouchAt = Date.now();
    var card = getCard(e.target);
    if (card) openModal(card);
  }, { passive: false, capture: true });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.m-atc-btn')) return;
    e.stopPropagation();
    e.preventDefault();
    if (Date.now() - lastTouchAt < 800) return;
    var card = getCard(e.target);
    if (card) openModal(card);
  }, true);

  /* ================================================================
     SOLD-OUT SORT
     Moves sold-out product items to the end of every collection grid.
     Stamps fs-sold-out class on cards with a VISIBLE sold-out badge
     (the badge exists in DOM for all products but display:none when in-stock).
  ================================================================ */
  function sortSoldOutToBottom() {
    var grids = document.querySelectorAll('.m-collection-products');
    grids.forEach(function (grid) {
      var items    = Array.from(grid.querySelectorAll(':scope > .m-product-item'));
      var inStock  = [];
      var soldOut  = [];
      items.forEach(function (item) {
        var badge = item.querySelector('.m-product-tag--soldout');
        /* Badge exists in DOM for ALL products — only treat as sold-out when actually visible */
        var isSoldOut = badge && window.getComputedStyle(badge).display !== 'none';
        /* Stamp helper class so CSS can dim only truly-sold-out cards */
        var card = item.querySelector('.m-product-card, .m-cascading-product-card');
        if (card) {
          if (isSoldOut) {
            card.classList.add('fs-sold-out');
          } else {
            card.classList.remove('fs-sold-out');
          }
        }
        if (isSoldOut) {
          soldOut.push(item);
        } else {
          inStock.push(item);
        }
      });
      /* Only re-append if ordering actually needs to change */
      var needsSort = soldOut.some(function (el, i) {
        return el !== items[inStock.length + i];
      });
      if (!needsSort) return;
      inStock.forEach(function (el) { grid.appendChild(el); });
      soldOut.forEach(function (el) { grid.appendChild(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortSoldOutToBottom);
  } else {
    sortSoldOutToBottom();
  }

  var sortObserver = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          n.classList.contains('m-product-item') ||
          n.querySelector && n.querySelector('.m-product-item')
        );
      });
    });
    if (relevant) sortSoldOutToBottom();
  });
  sortObserver.observe(document.body, { childList: true, subtree: true });

})();
;(function(){
  // #5  Oswald for the spotlight eyebrow
  var l=document.createElement('link');
  l.rel='stylesheet';
  l.href='https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&display=swap';
  document.head.appendChild(l);

  // Suppress the old "quick add" (fs-qa) popup ONLY on desktop (mobile keeps its working quick-add)
  var st=document.createElement('style');
  st.textContent='@media(min-width:768px){.fs-qa-overlay,.fs-qa-modal{display:none !important}}';
  document.head.appendChild(st);
  try{ new MutationObserver(function(){ if(window.innerWidth>=768 && document.body.classList.contains('fs-qa-open')) document.body.classList.remove('fs-qa-open'); }).observe(document.body,{attributes:true,attributeFilter:['class']}); }catch(e){}

  var BAG='M352 128C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 48c44.112 0 80 35.888 80 80H144c0-44.112 35.888-80 80-80zm176 384c0 17.645-14.355 32-32 32H80c-17.645 0-32-14.355-32-32V176h48v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h160v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h48v256z';

  // #10  Direction-A icons for the "Why Free Society" marquee (matched by label text)
  var A='fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"';
  var IC=[
    {re:/authenticity|authentic/i, svg:'<svg viewBox="0 0 52 52" '+A+'><circle cx="24" cy="24" r="13"/><ellipse cx="24" cy="24" rx="5.5" ry="13"/><line x1="11" y1="24" x2="37" y2="24"/><path d="M12.5 18.5h23M12.5 29.5h23" opacity=".5"/><path d="M29 34l4.5 4.5L45 27" stroke-width="3"/></svg>'},
    {re:/lowest price|price/i, svg:'<svg viewBox="0 0 52 52" '+A+'><path d="M27 7H40a3 3 0 0 1 3 3V23L25 41a3 3 0 0 1-4.2 0L8 28.2a3 3 0 0 1 0-4.2Z"/><circle cx="35" cy="15" r="2.4" fill="currentColor" stroke="none"/><path d="M16.5 20v14M11 29l5.5 6 5.5-6" stroke-width="2.6"/></svg>'},
    {re:/curation|sneaker/i, svg:'<svg viewBox="0 0 52 52" '+A+'><path d="M26 7 L38 21 L26 45 L14 21 Z"/><path d="M14 21 H38"/><path d="M26 7 L20 21 M26 7 L32 21"/><path d="M20 21 L26 45 M32 21 L26 45"/></svg>'}
  ];
  var lastMq=0;
  function fixMarquee(){
    try{
      var t=Date.now(); if(t-lastMq<700) return; lastMq=t;
      var labels=[].slice.call(document.querySelectorAll('span,p,div,h3,h4,h5,strong')).filter(function(e){
        if(e.children.length!==0) return false;
        var s=(e.textContent||'').trim();
        return s.length>3 && s.length<44 && /(authenticity|lowest price|curation|best sneaker)/i.test(s);
      });
      labels.forEach(function(le){
        // relabel "Best Sneaker Curation" -> "Best Curation"
        if(/sneaker/i.test(le.textContent) && /curation/i.test(le.textContent)){
          le.textContent=le.textContent.replace(/sneaker\s*/i,'').replace(/\s{2,}/g,' ').trim();
        }
        // find the item's icon (nearest svg/img up the tree)
        var item=le, icon=null, hops=0;
        while(item && hops<5){ icon=item.querySelector('svg,img'); if(icon) break; item=item.parentElement; hops++; }
        if(!icon || (icon.dataset && icon.dataset.fsSwapped)) return;
        var m=IC.filter(function(x){return x.re.test(le.textContent) || x.re.test((item.textContent||''));})[0];
        if(!m) return;
        var w=Math.round(icon.getBoundingClientRect().width)||48;
        var tmp=document.createElement('div'); tmp.innerHTML=m.svg;
        var ni=tmp.firstElementChild;
        ni.setAttribute('width',w); ni.setAttribute('height',w);
        ni.dataset.fsSwapped='1';
        icon.replaceWith(ni);
      });
    }catch(e){}
  }

  var scheduled=false, last=0;
  function apply(){
    scheduled=false;
    document.querySelectorAll('.m-atc-btn').forEach(function(b){
      if(window.innerWidth>=768 && b.getAttribute('data-action')) b.removeAttribute('data-action'); // block native size-picker on desktop only
      if(!b.dataset.fsIcon){ b.dataset.fsIcon='1'; var s=b.querySelector('svg'); if(s){ s.setAttribute('viewBox','0 0 448 512'); s.innerHTML='<path d="'+BAG+'"></path>'; } } // #3
    });
    document.querySelectorAll('.m-product-tag--sale').forEach(function(t){ // #7
      if(t.dataset.fsTag) return;
      var m=(t.textContent||'').match(/(\d{1,3})\s*%/);
      if(m){ t.dataset.fsTag='1'; t.textContent=''; var s=document.createElement('span'); s.textContent='Save '+m[1]+'%'; t.appendChild(s); }
    });
    var c=document.querySelector('.m-cart-count-bubble.m-cart-count, .m-cart-count'); // #8
    var n=c?parseInt((c.textContent||'0').replace(/\D/g,''),10):0;
    document.documentElement.classList.toggle('fs-has-items', n>0);
    fixMarquee();
  }
  function schedule(){ if(scheduled) return; scheduled=true; (window.requestAnimationFrame||window.setTimeout)(apply); }

  // #1  DESKTOP ONLY: card add-to-cart opens the quick view (single popup). Mobile keeps its native quick-add.
  document.addEventListener('click', function(e){
    if(window.innerWidth<768) return;
    var b=e.target.closest('.m-atc-btn'); if(!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    document.body.classList.remove('fs-qa-open');
    var t=Date.now(); if(t-last<600) return; last=t;
    var card=b.closest('.m-product-card,.m-product-item'); if(!card) return;
    var a=card.querySelector('a[href*="/products/"]'); if(!a) return;
    var m=a.getAttribute('href').match(/\/products\/([^/?#]+)/); if(!m) return;
    try{ window.MinimogTheme.ProductQuickView.loadProductQuickView(m[1]); }
    catch(err){ location.href=a.href; }
  }, true);

  function run(){ apply(); try{ new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true}); }catch(e){} }
  if(document.body) run(); else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', apply);
  window.addEventListener('scroll', function(){ fixMarquee(); }, {passive:true});

  // #4  Windowed spotlight dots on desktop only — isolated, display-only, cannot affect the slider's animation
  function windowDots(d){
    var dots=[].slice.call(d.querySelectorAll('.fe-dots__dot'));
    if(window.innerWidth<768 || dots.length<=9){ dots.forEach(function(x){ x.style.display=''; }); return; }
    var a=d.querySelector('.fe-dots__dot.is-active'); var idx=dots.indexOf(a); if(idx<0) idx=0;
    dots.forEach(function(x,i){ x.style.display=Math.abs(i-idx)<=3?'':'none'; });
  }
  function initDots(){
    document.querySelectorAll('.fe-dots').forEach(function(d){
      windowDots(d);
      if(d.dataset.fsDots) return; d.dataset.fsDots='1';
      try{ new MutationObserver(function(){ windowDots(d); }).observe(d,{attributes:true,subtree:true,attributeFilter:['class']}); }catch(e){}
    });
  }
  function dotsRun(){ initDots(); try{ new MutationObserver(initDots).observe(document.body,{childList:true,subtree:true}); }catch(e){} }
  if(document.body) dotsRun(); else document.addEventListener('DOMContentLoaded', dotsRun);
  window.addEventListener('resize', function(){ document.querySelectorAll('.fe-dots').forEach(windowDots); });;(function(){function fsQV(b){var c=b.closest(".m-product-card,.m-product-item,.m-cascading-product-card");var a=c&&c.querySelector('a[href*="/products/"]');if(!a)return;var m=a.getAttribute("href").match(new RegExp("/products/([^/?#]+)"));if(!m)return;try{document.body.classList.remove("fs-qa-open");window.MinimogTheme.ProductQuickView.loadProductQuickView(m[1]);}catch(e){location.href=a.href;}}function fsH(e){var t=e.target,b=t&&t.closest?t.closest(".m-atc-btn"):null;if(!b)return;e.preventDefault();e.stopImmediatePropagation();var n=Date.now();if(e.type==="touchstart"){b.__fsT=n;fsQV(b);return;}if(b.__fsT&&n-b.__fsT<800)return;fsQV(b);}window.addEventListener("touchstart",fsH,{capture:true,passive:false});window.addEventListener("click",fsH,true);})();
})();
